import { Shift } from './types';
import { createShiftDate } from './date-utils';

const VTIMEZONE = `BEGIN:VTIMEZONE
TZID:Australia/Melbourne
BEGIN:STANDARD
DTSTART:19700405T030000
RRULE:FREQ=YEARLY;BYDAY=1SU;BYMONTH=4
TZOFFSETFROM:+1100
TZOFFSETTO:+1000
TZNAME:AEST
END:STANDARD
BEGIN:DAYLIGHT
DTSTART:19701004T020000
RRULE:FREQ=YEARLY;BYDAY=1SU;BYMONTH=10
TZOFFSETFROM:+1000
TZOFFSETTO:+1100
TZNAME:AEDT
END:DAYLIGHT
END:VTIMEZONE`;

function formatIcsDateTime(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${y}${m}${d}T${h}${min}${s}`;
}

function formatIcsDateOnly(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}${m}${d}`;
}

export function generateIcs(shifts: Shift[]): string {
  const events: string[] = [];
  let uid = 0;
  const now = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

  for (const shift of shifts) {
    const dtStamp = now + 'Z';
    const uidVal = `roster-convert-${Date.now()}-${uid++}@app`;

    if (shift.type === 'shift' && shift.startTime && shift.endTime) {
      const startDate = createShiftDate(shift.date, shift.startTime);
      const endDate = createShiftDate(shift.date, shift.endTime, true, shift.startTime);

      events.push(
        `BEGIN:VEVENT`,
        `DTSTART;TZID=Australia/Melbourne:${formatIcsDateTime(startDate)}`,
        `DTEND;TZID=Australia/Melbourne:${formatIcsDateTime(endDate)}`,
        `DTSTAMP:${dtStamp}`,
        `UID:${uidVal}`,
        `SUMMARY:${shift.label}`,
        shift.location ? `DESCRIPTION:Location: ${shift.location}` : '',
        `END:VEVENT`
      );
    } else {
      const dateStr = formatIcsDateOnly(shift.date);
      events.push(
        `BEGIN:VEVENT`,
        `DTSTART;VALUE=DATE:${dateStr}`,
        `DTEND;VALUE=DATE:${dateStr}`,
        `DTSTAMP:${dtStamp}`,
        `UID:${uidVal}`,
        `SUMMARY:${shift.label}`,
        `TRANSP:TRANSPARENT`,
        `END:VEVENT`
      );
    }
  }

  return [
    `BEGIN:VCALENDAR`,
    `VERSION:2.0`,
    `PRODID:-//Roster Convert//EN`,
    `CALSCALE:GREGORIAN`,
    `METHOD:PUBLISH`,
    VTIMEZONE,
    ...events,
    `END:VCALENDAR`,
  ].join('\r\n');
}

export function downloadIcs(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}